<template>
    <div class="user-cards-container">
        <a-drawer
            title="Felhasználó tulajdonságai."
            :width="520"
            v-on:close="closeDrawer"
            :visible="drawerOpen"
            :wrapClassName="'drawer-container'"
        >
            <UserFormComponent 
                :formValues="formValues"
            />
        </a-drawer>
        <div class="card-grid">
            <a-row
                class="user-cards-row"
                v-for="(row, ix) in usersGrid"
                :gutter="24"
                :key="ix"
            >
                <a-col 
                    v-for="(col, jx) in row"
                    :key="jx"
                    :span="24 / row.length"
                >
                    <user-card-component
                        :title="`${col.firstName} ${col.lastName}`"
                        :id="col.id"
                        :editClicked="editUser"
                    >
                    </user-card-component>
                </a-col>
            </a-row>
        </div>
    </div>
</template>

<script>
import UserCardComponent from './UserCardComponent.vue';
import UserFormComponent from './UserFormComponent.vue';


export default {
    components: {
        UserCardComponent,
        UserFormComponent
    },


    data() {
        return {
            drawerOpen: false,
            formValues: {
                firstName: '',
                lastName: ''
            },

            cols: 3,
            users: [
                {
                    firstName: 'Kis',
                    lastName: 'Jozsi',
                    id: 1
                },
                {
                    firstName: 'ASD',
                    lastName: 'Jozsi',
                    id: 2
                },
                {
                    firstName: 'Kis',
                    lastName: 'GGGGGGG',
                    id: 3
                },
                {
                    firstName: 'Kis',
                    lastName: 'Jozsi',
                    id: 4
                },
                {
                    firstName: 'FDSFDs',
                    lastName: 'FSDF',
                    id: 5
                },
                {
                    firstName: 'sAdfsd',
                    lastName: 'JozsGDFGDFi',
                    id: 6
                },
                {
                    firstName: 'Kis',
                    lastName: 'Jozsi',
                    id: 7
                },
                {
                    firstName: 'Kis',
                    lastName: 'FGDFG',
                    id: 8
                }
            ]
        }
    },

    computed: {
        usersGrid() {
            const rows = Math.round(this.users.length / this.cols);
            let grid = [];
            
            for (let i = 0; i < rows; i++) {
                let row = [];
                for (let j = 0; j < this.cols; j++) {
                    let idx = i * this.cols + j;
                    if (this.users[idx]) {
                        row.push(this.users[idx])
                    }
                }
                grid.push(row);
            }
            return grid;
        }
        
    },

    methods: {
        editUser(id) {
            const user = this.users.find(el => el.id === id);
            
            this.formValues = {
                firstName: user.firstName,
                lastName: user.lastName
            }
            this.drawerOpen = true;
        },

       closeDrawer(ev) {
          this.drawerOpen = false;
       }
    }

}
</script>

<style lang="scss" scoped>
    .user-cards-row {
        margin-top: 18px;
        
    }
</style>
